import React from 'react';
import { Callout, CalloutProps } from './Callout';

export const Warning: React.FC<Omit<CalloutProps, 'type'>> = (props) => (
  <Callout type="warning" {...props} />
);

export default Warning;
